import { Component } from '@angular/core';

@Component({
    selector: 'app-circle-danger',
    template: `
        <app-custom-circle-icon color="danger-color">
            <i class="material-icons" icon>dangerous</i>
        </app-custom-circle-icon>
    `,
})
export class CircleDangerComponent {}
